




































import { computed, defineComponent, ref } from '@vue/composition-api';
import { BaseInput } from '../base-input';
import { BaseIcon } from '../base-icon';

export default defineComponent({
  components: {
    BaseInput,
    BaseIcon,
  },
  props: {
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    open: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    searchable: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    errorMessage: { type: String, default: '' },
    helpMessage: { type: String, default: '' },
    success: { type: Boolean, default: false },
    fixedLabel: { type: Boolean, default: false },
    value: { type: String, default: '' },
    dataExternal: { type: String, default: '' },
  },
  setup(props, { emit }) {
    const readonly = computed(() => !props.searchable || !props.open);
    const inputRef = ref<HTMLInputElement | null>(null);

    const handleKey = (event: KeyboardEvent) => {
      if (props.disabled) return;

      switch (event.key) {
        case 'ArrowUp':
          event.preventDefault();
          emit('arrowUp', event);
          break;
        case 'ArrowDown':
          event.preventDefault();
          emit('arrowDown', event);
          break;
        case 'Enter':
          emit('enter', event);
          break;
        case ' ':
          emit('space', event);
          break;
        case 'Escape':
          emit('close', event);
          break;
        default:
          break;
      }
    };

    const handleClick = () => {
      if (props.disabled) return;

      emit('click');
    };

    const handleChevronClick = () => {
      if (props.disabled) return;

      if (inputRef.value && !props.open) {
        inputRef.value.focus();
      }

      handleClick();
    };

    return {
      handleKey,
      handleClick,
      readonly,
      inputRef,
      handleChevronClick,
    };
  },
});
